import React from "react";
// react admin
import { useGetIdentity } from "react-admin";
//react router
import { useNavigate } from "react-router-dom";
// mui
import { Grid } from "@mui/material";
// components
import { WalletSummary } from "./Summary/WalletSummary";
import { UserSummary } from "./Summary/UserSummary";
import { GamePerformance } from "./Summary/GamePerformance";
import { RecentTransactions } from "./Summary/RecentTransactions";
import { UserEngagement } from "./Summary/UserEngagement";
import { HotGames } from "./Summary/HotGames";
import { MarketingCarousel } from "./Summary/MarketingCarousel";

export const Dashboard = () => {
  const { data } = useGetIdentity();
  const navigate = useNavigate();

  const currentUserData = localStorage.getItem(
    `Parse/${process.env.REACT_APP_APP_ID}/currentUser`
  );

  if (!currentUserData) {
    navigate("/login");
  }

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <UserSummary />
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12}>
          <WalletSummary />
        </Grid> */}
        {data && data?.userRoleName === "Super-User" && (
          <Grid item xs={12} sm={12} md={12}>
            <MarketingCarousel />
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={12}>
          <HotGames />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={data && data?.userRoleName === "Super-User" ? 6 : 12}
        >
          <RecentTransactions />
        </Grid>
        {data && data?.userRoleName === "Super-User" && (
          <Grid item xs={12} sm={12} md={6}>
            <GamePerformance />
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={12}>
          <UserEngagement />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
